import Vue from 'vue'
import { isUndefined } from '@rrc/utils'
import { getQueryParam } from '@/utils/util'
import { IS_TOB_APP } from '@/utils'
import { IS_WECHAT_WORK, isBusinessPlatform, tokenExpired, IS_FIX_PRICE } from '@/utils/platform-interact'
import { GATEWAY_USER_AGENT, ISPRODUCTION, FIXPRICE_USER_AGENT, PRIVATE_KEY_SECRET } from '@/config/global.config';
import { generateJWT } from '@/utils/generate-jwt'

let JWTHEADER // 共享jetHeader数据

function getRequestHeader(config) {
  config.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  if (isBusinessPlatform()) {
      let jwtHeader = JWTHEADER
      console.log(jwtHeader);
      if (jwtHeader === undefined) {
        jwtHeader = (window.localStorage && window.localStorage.getItem('jwtHeader')) || null
        jwtHeader = jwtHeader && JSON.parse(jwtHeader)
        JWTHEADER = jwtHeader
      }
      if (jwtHeader) {
        config.headers.common['authorization'] = jwtHeader['Authorization']
        config.headers.common['GATEWAY-LOGIN-TOKEN'] = jwtHeader['GATEWAY-LOGIN-TOKEN']
        config.headers.common['GATEWAY-USER-AGENT'] = jwtHeader['GATEWAY-USER-AGENT'] || window.navigator.userAgent
      }

      // 本地开发环境模式jwt数据
      // const DEVJWTHEADER = {
      //   "Authorization": '',
      //   "GATEWAY-LOGIN-TOKEN": '',
      //   "GATEWAY-USER-AGENT": ''
      // }
      // if(process.env.NODE_ENV === 'development'){
      //   config.headers.common['authorization'] = DEVJWTHEADER['Authorization']
      //   config.headers.common['GATEWAY-LOGIN-TOKEN'] = DEVJWTHEADER['GATEWAY-LOGIN-TOKEN']
      //   config.headers.common['GATEWAY-USER-AGENT'] = DEVJWTHEADER['GATEWAY-USER-AGENT'] || window.navigator.userAgent
      // }
  } else if (IS_WECHAT_WORK) {
      // 从url中获取token
      const accessToken = (window.sessionStorage && window.sessionStorage.getItem('accessToken')) || getQueryParam('accessToken') || null;

      if (accessToken) {
          config.headers.common['GATEWAY-LOGIN-TOKEN'] = accessToken;
          config.headers.common['GATEWAY-USER-AGENT'] = GATEWAY_USER_AGENT;
          config.headers.common['Customer-Manage-Login-Source'] = 30;
      }

      // 因为企业微信没有测试环境，所以，为了限制沙盒环境访问企业微信，要求在沙盒环境访问的时候，header里，要加一个我们配置授权的userId
      if(!ISPRODUCTION){
        config.headers.common.userId = '1743379';
      }
      // // //  企业微信中调用登录接口时需要business_code 用于识别调用方
      // config.headers.common.businessCode = 'saleCustomerManage';
  } else if (IS_FIX_PRICE) {
    let accessToken = (window.sessionStorage && window.sessionStorage.getItem('accessToken')) || getQueryParam('accessToken') || null;
    if (accessToken) {
        config.headers.common['GATEWAY-LOGIN-TOKEN'] = accessToken;
        config.headers.common['GATEWAY-USER-AGENT'] = FIXPRICE_USER_AGENT;
    }
  }

  // 如果有isSharePath，说明需要使用与网关约定好的key、secret 手动生成jwt，进行鉴权
  if(config.isSharePath) {
    // 获取对应业务线的key、secret
    const privateKeySecret = PRIVATE_KEY_SECRET[config.bussinessName]
    const { key, secret } = ISPRODUCTION ? privateKeySecret['production'] : privateKeySecret['test']
    config.headers.common.authorization = generateJWT(key, secret)
  }
  return config;
}

/* eslint-disable */
function install (Http) {
  Http.mixin({
    // 请求 resolve 钩子
    $requestResolve (config) {
      // config.headers.common['X-Requested-With'] = 'XMLHttpRequest'
      // let jwtHeader = JWTHEADER
      // if (jwtHeader === undefined) {
      //   jwtHeader = (window.localStorage && window.localStorage.getItem('jwtHeader')) || null
      //   jwtHeader = jwtHeader && JSON.parse(jwtHeader)
      //   JWTHEADER = jwtHeader
      // }
      // if (jwtHeader) {
      //   config.headers.common['authorization'] = jwtHeader['Authorization']
      //   config.headers.common['GATEWAY-LOGIN-TOKEN'] = jwtHeader['GATEWAY-LOGIN-TOKEN']
      //   config.headers.common['GATEWAY-USER-AGENT'] = jwtHeader['GATEWAY-USER-AGENT'] || window.navigator.userAgent
      // }
      // return config
      if(IS_TOB_APP && window.location.hash.indexOf('/customerIntention') != -1) {
        return config
      }
      return getRequestHeader(config)
    },
    // 响应成功 钩子
    $responseResolve (response) {
      return response
    },
    // 响应失败 或者 400 500 等错误
    $responseReject (error) {
      const response = error.response
      if (response === undefined) {
        Vue.prototype.$toast('网络异常，请稍后再试')
        return Promise.reject(error)
      }
      let {data: {errMsg, err_msg, message, errmsg, msg, error_msg}, status} = response // eslint-disable-line
      if (status === 401) { // 未登陆
        Vue.prototype.$dialog.alert({ message: '登录信息获取失败，请重新登录' }).then(_ => {
          tokenExpired()
        })
        return Promise.reject(error)
      }
      const msgStr = errMsg || err_msg || message || errmsg || msg || error_msg // eslint-disable-line
      if (msgStr) { // eslint-disable-line
        Vue.prototype.$dialog.alert({
          closeOnPopstate: true,
          title: '提示',
          message: msgStr
        })
      }
      return Promise.reject(error)
      // return error
    },

    // 重写 方法 -- 该方法仅在 response的接口业务状态中status!=0时生效
    $message (response, isReject = false) {
      if (isReject) {
        Vue.prototype.$toast(response || '网络异常，请稍后再试')
        return
      }
      const { data: { errMsg, err_msg, message, errmsg, msg, error_msg } } = response // eslint-disable-line
      let msgStr = errMsg || err_msg || message || errmsg || msg || error_msg // eslint-disable-line
      msgStr && Vue.prototype.$toast(msgStr)
    },

    $autoMessageAdapter (response) {
      const { data: { code, status } } = response
      if (isUndefined(code) && isUndefined(status)) { // 为了兼容非标准response的结构返回
        return false
      }
      if (code === 0 || code === '0' || status === 0 || status === '0') {
        return false
      }
      delete (response.data).ts
      return true
    }
  })
}

export default {
  install
}
